<template>
  <div
    class="is-flex is-align-items-center is-justify-content-center has-text-centered"
    @click.stop
  >
    <b-dropdown
      class="dropdown-actions-process"
      position="is-bottom-left"
      append-to-body
      :mobile-modal="false"
      trap-focus
    >
      <button
        class="button is-small"
        slot="trigger"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        title="Más acciones"
      >
        <span class="icon is-small">
          <i class="material-icons">more_horiz</i>
        </span>
      </button>

      <b-dropdown-item v-on:click="onEdit">
        <span class="icon is-small">
          <i class="mdi mdi-pencil"></i>
        </span>
        <span>Editar</span>
      </b-dropdown-item>

      <b-dropdown-item v-on:click="onDelete">
        <span class="icon is-small">
          <i class="mdi mdi-delete"></i>
        </span>
        <span>Eliminar</span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: "ActionsProcess",
  methods: {
    onEdit() {
      const componentParent = this.params.context.componentParent;
      componentParent.handleShowEdit(this.params.data);
    },
    onDelete() {
      const componentParent = this.params.context.componentParent;
      componentParent.handleDelete(this.params.data._id);
    },
  },
};
</script>
<style>
.dropdown-actions-process .dropdown-trigger {
  display: flex;
}
.dropdown-actions-process .dropdown-trigger .button:focus {
  border-color: unset !important;
  box-shadow: unset !important;
}
</style>
<style scoped>
.dropdown-actions-process .button.is-small {
  border: none;
  background: transparent;
  padding: 0.25rem;
  width: 25px;
  height: 25px;
}

.dropdown-actions-process .button.is-small:hover {
  background: #ededed;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/components/Process/ActionsProcess.vue